import { LDivider, LFlex, LInputRow } from "@components";
import { InputFieldProps } from "@components/LInputField";
import { Control, useWatch } from "react-hook-form";
import { OrganizationForm } from "../pages/createOrganization";

export const AssessmentQuantity = ({ control }: { control: Control<OrganizationForm> }): JSX.Element => {
    const assessmentQuantity = Number(useWatch({ control, name: "assessmentQuantity", defaultValue: 0 }));
    const unitPrice = Number(useWatch({ control, name: "unitPrice", defaultValue: 0 }));
    const discount = Number(useWatch({ control, name: "discount", defaultValue: 0 }));

    const subTotal = assessmentQuantity * unitPrice;
    const discountTotal = (subTotal * discount) / 100;
    const total = subTotal - discountTotal;

    const inputs = [
        {
            label: "Assessment Quantity",
            type: "number",
            inputName: "assessmentQuantity",
            placeholder: "Enter quantity",
            defaultValue: ""
        } as InputFieldProps,
        {
            label: "Unit Price $",
            type: "number",
            inputName: "unitPrice",
            placeholder: "Enter unit price",
            defaultValue: ""
        } as InputFieldProps,
        {
            label: "Discount % (optional)",
            type: "text",
            isNumber: true,
            inputName: "discount",
            placeholder: "Enter discount %",
            defaultValue: "",
            maxLength: 2
        } as InputFieldProps
    ];

    return (
        <>
            <LInputRow inputs={inputs} />
            <div
                className="mt-3 p-5 has-background-light-blue has-text-ldark-gray is-borders-rounded"
                style={{ maxWidth: "60%" }}
            >
                <LFlex row alignCenter className="is-justify-content-space-between">
                    <p>Subtotal</p>
                    <p>${subTotal?.toFixed(2)}</p>
                </LFlex>
                <LFlex row alignCenter className="is-justify-content-space-between">
                    <p>Discount</p>
                    <p>${discountTotal?.toFixed(2)}</p>
                </LFlex>
                <LDivider isFat />
                <LFlex row alignCenter className="is-justify-content-space-between">
                    <p className="has-text-weight-bold is-size-5">Total</p>
                    <p className="has-text-weight-bold is-size-5">${total?.toFixed(2)}</p>
                </LFlex>
            </div>
        </>
    );
};
